// The columns of the companies' table between « Entreprise », which always
// stays first, and the commercial, always last (FIXED_LAST), in their default
// order (`label`: their key in the locales, `title`: a French title written
// here instead). A tab shows those it has
// (TAB_COLUMNS), in the order chosen in « Personnaliser les colonnes »
// (ModalCustomizeVivierColumns), kept in the browser.
export const COMPANY_COLUMNS = [
  { key: 'size', title: 'Taille' },
  { key: 'department', label: 'columnDepartment' },
  { key: 'category', label: 'columnCategory' },
  { key: 'group', label: 'columnGroup' },
  { key: 'action', label: 'columnAction' },
  { key: 'created', label: 'columnCreated' },
  { key: 'recruiter', label: 'columnRecruiter' },
  { key: 'reason', label: 'columnReason' },
  { key: 'relaunch', label: 'columnRelaunch' },
  { key: 'lostOn', label: 'columnLostOn' },
];
export const FIXED_LAST = { key: 'commercial', label: 'columnCommercial' };

export const TAB_COLUMNS = {
  prospects: ['size', 'department', 'category', 'group', 'action', 'created'],
  new: ['size', 'department', 'category', 'group', 'action'],
  old: ['size', 'department', 'category', 'group', 'action', 'recruiter'],
  lost: ['size', 'department', 'category', 'reason', 'relaunch', 'lostOn'],
};

export const COMPANY_COLUMNS_DEFAULT = COMPANY_COLUMNS.map((column) => column.key);
export const COMPANY_COLUMNS_KEY = 'companies_admin_columns';
export const COMPANY_COLUMNS_UPDATED = 'companies_columns_updated';

// The title of a column, its own or its key's in the locales.
export const columnTitle = (column, text) => column.title ?? text(column.label);

// The cells after « Entreprise » on a tab: those chosen it has, then the commercial.
export const columnsOfTab = (chosen, tab) => [
  ...chosen.filter((key) => TAB_COLUMNS[tab].includes(key)),
  FIXED_LAST.key,
];

// A column that came after a choice could be kept: a choice made before it
// gets it once, first, so that it is not hidden from whoever had customized
// the table; taken off since, it stays off.
const ADDED_COLUMNS = ['size'];
const ADDED_COLUMNS_KEY = 'companies_admin_columns_size_added';

// The columns kept from the browser, or all of them.
export const storedCompanyColumns = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(COMPANY_COLUMNS_KEY));
    if (!Array.isArray(stored)) {
      // The defaults already hold it: a choice saved later must not get it back.
      localStorage.setItem(ADDED_COLUMNS_KEY, '1');
      return COMPANY_COLUMNS_DEFAULT;
    }
    const known = stored.filter((key) => COMPANY_COLUMNS_DEFAULT.includes(key));
    if (localStorage.getItem(ADDED_COLUMNS_KEY)) return known;
    const columns = [...ADDED_COLUMNS.filter((key) => !known.includes(key)), ...known];
    localStorage.setItem(COMPANY_COLUMNS_KEY, JSON.stringify(columns));
    localStorage.setItem(ADDED_COLUMNS_KEY, '1');
    return columns;
  } catch {
    return COMPANY_COLUMNS_DEFAULT;
  }
};
